// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "* {\n  font-family: \"Nekro One\", cursive;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/categorias/categorias.component.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ","sourcesContent":["* {\r\n    font-family: 'Nekro One', cursive;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
